import { render, staticRenderFns } from "./RecapOrder.vue?vue&type=template&id=1931573d&scoped=true&"
import script from "./RecapOrder.vue?vue&type=script&lang=js&"
export * from "./RecapOrder.vue?vue&type=script&lang=js&"
import style0 from "./RecapOrder.vue?vue&type=style&index=0&id=1931573d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931573d",
  null
  
)

export default component.exports